function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react'; // original author: dcarter

import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getFirstAvailableChildId } from '../utils/children';
import Label from '../label/Label';
import * as constants from './constants';
/**
 * Helper component that conditionally renders an annotation note
 * @prop {string} annotationNote - string to be displayed in annotation
 * @example
 * // <FormFieldNote annotationNote="This field is required" />
 */

var FormFieldNote = function FormFieldNote(_ref) {
  var annotationNote = _ref.annotationNote;
  var component = null;

  if (annotationNote) {
    component = React.createElement("aside", {
      "data-automation": "eds-field-annotation",
      className: "eds-field-annotation__note eds-l-pad-top-1 eds-fx--fade-in",
      role: "alert"
    }, annotationNote);
  }

  return component;
};
/**
 * Class that represents a general form-field wrapper.
 * Dictates how label, field message, etc are structured around form fields.
 * In simple cases, htmlFor can be automatically determined from child form element.
 * @extends PureComponent
 * @example
 * // <FormField label="My Input" required={true}>
 * //     <Input id="my-input" type="text" />
 * // </FormField>
 **/


var FormField =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FormField, _PureComponent);

  function FormField() {
    _classCallCheck(this, FormField);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormField).apply(this, arguments));
  }

  _createClass(FormField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          required = _this$props.required,
          hideLabel = _this$props.hideLabel,
          annotationType = _this$props.annotationType,
          annotationNote = _this$props.annotationNote,
          bottomSpacing = _this$props.bottomSpacing,
          children = _this$props.children,
          _this$props$htmlFor = _this$props.htmlFor,
          htmlFor = _this$props$htmlFor === void 0 ? getFirstAvailableChildId(children) : _this$props$htmlFor;
      var containerClassname = classNames("eds-l-mar-bot-".concat(bottomSpacing));
      var labelClassname = classNames({
        'eds-l-mar-bot-1': !hideLabel
      }, 'eds-text--left');
      var annotationWrapClassname = classNames({
        'eds-field-annotation': annotationNote,
        'eds-field-annotation--success': annotationType === constants.ANNOTATION_TYPE_SUCCESS,
        'eds-field-annotation--error': annotationType === constants.ANNOTATION_TYPE_ERROR
      });
      return React.createElement("div", {
        className: containerClassname
      }, React.createElement("div", {
        className: labelClassname
      }, React.createElement(Label, {
        htmlFor: htmlFor,
        required: required,
        hidden: hideLabel
      }, label)), React.createElement("div", {
        className: annotationWrapClassname
      }, children, React.createElement(FormFieldNote, {
        annotationNote: annotationNote
      })));
    }
  }]);

  return FormField;
}(PureComponent);

_defineProperty(FormField, "propTypes", {
  /**
   * FormField should be provided with a single form element.
   */
  children: PropTypes.element.isRequired,

  /**
   * Text to be displayed in label
   */
  label: PropTypes.node.isRequired,

  /**
   * Id of the input to which the label is mapped; optional
   */
  htmlFor: PropTypes.string,

  /**
   * Whether this field is required
   */
  required: PropTypes.bool,

  /**
   * Whether the label should be displayed or hidden
   */
  hideLabel: PropTypes.bool,

  /**
   * The type of annotation message that should be shown
   */
  annotationType: PropTypes.oneOf(constants.ANNOTATION_TYPES),

  /**
   * Text shown in annotation message
   */
  annotationNote: PropTypes.node,

  /**
   * The amount of spacing for the bottom
   */
  bottomSpacing: PropTypes.number
});

_defineProperty(FormField, "defaultProps", {
  required: false,
  hideLabel: false,
  annotationType: constants.ANNOTATION_TYPE_INFO,
  bottomSpacing: 5
});

export { FormField as default };